module.exports = __webpack_public_path__ + "img/at-work.1e445dad.svg";